import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DefaultScheduleService } from 'app/core/services/default-schedule.service';
import { PrivateService } from 'app/core/services/private.service';
import { ProcessSchedulerService } from 'app/core/services/process-scheduler.service';
import { Observable, startWith, map } from 'rxjs';

@Component({
  selector: 'dialog-process-workdays',
  templateUrl: './dialog-process-workdays.component.html',
  styleUrls: ['./dialog-process-workdays.component.scss']
})
export class DialogProcessWorkdaysComponent implements OnInit {

  payrolls: any[] = [];
  period: any[] = [];
  processForm: FormGroup;
  employees: any[] = [];
  schedules: any[] = [];

  employeeCtrl = new FormControl('');
  scheduleCtrl = new FormControl('');
  payrollCtrl = new FormControl('');
  periodCtrl = new FormControl('');

  filteredEmployees!: Observable<any[]>;
  filteredSchedules!: Observable<any[]>;
  filteredPayrolls!: Observable<any[]>;
  filteredPeriods!: Observable<any[]>;

  isLoading: boolean = false;
  message: any;
  isProcessed: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogProcessWorkdaysComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private privateService: PrivateService, private fb: FormBuilder, private processSchedulerService: ProcessSchedulerService,
    private defaultScheduleService: DefaultScheduleService) {
    this.processForm = this.fb.group({
      employee: [0],
      payroll: [0, Validators.required],
      period: ['', Validators.required],
      schedule: [0]
    });
  }

  ngOnInit(): void {
    this.getPayrolls();
    this.getEmployees();

    this.periodCtrl.disable();

    this.filteredPayrolls = this.payrollCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value, this.payrolls, 'payrollType'))
    );

    this.filteredPeriods = this.periodCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value, this.period, 'payrollName'))
    );

    this.payrollCtrl.valueChanges.subscribe(value => {
      if (!value) {
        this.periodCtrl.disable();
        this.periodCtrl.setValue('');
      } else {
        this.periodCtrl.enable();
      }
    });
  }

  private _filter(value: string, list: any[], key: string): any[] {
    const filterValue = value?.toLowerCase() || '';
    return list?.filter(item => item[key]?.toLowerCase().includes(filterValue));
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getEmployees() {
    this.privateService.getEmployeeInfoAll().subscribe({
      next: res => {
        this.employees = res;
        this.filteredEmployees = this.employeeCtrl.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value, this.employees, 'employeeName'))
        );
      },
      error: err => {
        console.log(err);
      }
    })
  }

  getPayrolls() {
    this.privateService.getPayrollType().subscribe(res => {
      this.payrolls = res;
      this.filteredPayrolls = this.payrollCtrl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value, this.payrolls, 'payrollType'))
      );
    });
  }

  onEmployeeSelected(employeeName: string) {
    const selected: any = this.employees.find(d => d.employeeName === employeeName);
    if (selected) {
      this.processForm.get('employee')?.setValue(selected.C_BPartner_ID);
    }
    this.defaultScheduleService.getDefaultSchedulesEmployee(selected.C_BPartner_ID).subscribe(response => {
      this.schedules = response;
      this.filteredSchedules = this.scheduleCtrl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value, this.schedules, 'description'))
      );
    })
  }

  onPayrollSelected(payrollType: string) {
    const selected: any = this.payrolls.find(d => d.payrollType === payrollType);
    if (selected) {
      this.processForm.get('payroll')?.setValue(selected.hrpayrollID);
    }
    this.privateService.getPeriodOnDepartment(selected.hrpayrollID).subscribe(response => {
      console.log(response);
      this.period = response;
      this.filteredPeriods = this.periodCtrl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value, this.period, 'payrollName'))
      );
    })
  }

  onPeriodSelected(payrollName: string) {
    const selected = this.period.find(e => e.payrollName === payrollName);
    if (selected) {
      this.processForm.get('period')?.setValue(selected.hrperiodID);
    }
  }

  onScheduleSelected(description: string) {
    const selected = this.schedules.find(e => e.description === description);
    if (selected) {
      this.processForm.get('schedule')?.setValue(selected.id);
    }
  }

  onSubmit(): void {
    if (this.processForm.valid) {
      const formData = this.processForm.value;
      this.defaultScheduleService.generateEmployeeWorkdays(formData).subscribe((res) => {
        this.isLoading = false;
        this.isProcessed = true;
        this.message = res.message;
      });
    } else {
      console.log('Form is invalid');
    }
  }
}
